import { SupplierList } from 'components/Suppliers/SupplierList';

export const CruiseList: React.FC = () => (
  <SupplierList isHotelSupplier={false} />
);
